import { render, staticRenderFns } from "./InformationPanel.vue?vue&type=template&id=159e0787&scoped=true"
import script from "./InformationPanel.vue?vue&type=script&lang=js"
export * from "./InformationPanel.vue?vue&type=script&lang=js"
import style0 from "./InformationPanel.vue?vue&type=style&index=0&id=159e0787&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159e0787",
  null
  
)

export default component.exports